export default __webpack_public_path__ + "static/media/VIC-Driver.8d986618.png";